<template>
  <div v-if="(!loaded)"><AppSpinner /></div>
  <div v-if="(loaded)">
    <div :class="(item.imagem != null ? 'app-page-margin-withImage' : 'app-page-margin-withoutImage app-page-padding')">
      <AppImagem v-if="(item.imagem != null)" :imagem="item.imagem" :titulo="item.tituloImagem" :subtitulo="item.subtituloImagem" />
      <div :class="(item.imagem != null ? 'app-page-padding mt-8' : '')">
        <div class="paddingPagConteudo flex flex-column w-full">
          <AppTexto :titulo="item.titulo" :conteudo="item.conteudo" :tituloFirstDiv="item.titulo" class="mt-6" />
          <div class="flex mt-8" v-if="(item.anexo != null)">
            <div @click="fc_dialogPdf(item.anexo, item.anexoNome.toUpperCase())" class="flex rsa-button-blue" v-html="fc_getText(null, 'pdfOpen')"></div>
          </div>
        </div>
        <div v-if="(item.membros != null && item.membros.length > 0)" class="paddingPagConteudo app-page-margin-subpage-second">
          <AppTitleX :titulo="fc_getText(null, 'equipa', { title: true })" />
          <div v-if="(item.coordenadores != null && item.coordenadores.length > 0)">
            <div class="py-2 text-right rsa-font-montserrat-bold border-bottom-1 surface-border" v-html="fc_getText(null, 'coordenacao', { title: true })"></div>
            <div v-for="(forItem, forIndex) in item.coordenadores" :key="forIndex" class="py-2 text-right nomeLink" v-html="forItem.nome" @click="fc_goRoute('membro', { id: forItem.id })" ></div>
          </div>
          <div class="flex flex-wrap w-full gap-3 mt-4">
            <ListItemMembro v-for="(forItem, forIndex) in item.membros" :key="forIndex" :item="forItem" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListItemMembro from '@/components/ListItemMembro.vue';
export default {
  components: {
    ListItemMembro,
  },
  data() {
    return {
      loaded: false,
      item: {},
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.mt_loadData();
    },
    mt_loadData() {
      this.loaded = false;
      this.fc_fetch({ endpoint: 'InvestigacaoDesenvolvimento/', method: 'GET', success: this.mt_loadData_success, error: () => { this.mt_goBack(); } });
    },
    mt_loadData_success(response) {
      if (response != null && response.item != null) {
        this.item = response.item;
        this.loaded = true;
      } else {
        this.mt_goBack();
      }
    },
    mt_goBack() {
      this.fc_goRoute('home');
    },
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nomeLink:hover {
  color: var(--rsa-color);
  cursor:pointer;
}
</style>
